module.exports = __webpack_public_path__ + "img/input-number-icon.1330d02f.svg";